import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import { DialogContent, Typography, Hidden } from '@material-ui/core';

export default function Contact() {
  let [isLoading, setIsLoading] = React.useState(false);
  let [isSuccessDialogOpen, setIsSuccessDialogOpen] = React.useState(false);
  let [isFailedDialogOpen, setIsFailedDialogOpen] = React.useState(false);
  let [isEmailDialogOpen, setIsEmailDialogOpen] = React.useState(false);
  let [contactState, setContactState] = React.useState({
    name: '',
    email: '',
    contact: '',
    company: '',
    message: '',
    captcha: '',
  });

  const handleContactChange = (event) => {
    let { name, value } = event.target;

    setContactState(prevState => {
      return { ...prevState, [name]: value }
    });
  };

  const onCaptchaChange = (value) => {
    setContactState(prevState => {
      return { ...prevState, captcha: value };
    });
  };

  const submitContact = () => {
    if (contactState.captcha === "") {
      setIsFailedDialogOpen(true);
      return;
    }
    const emailRegex = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;

    if (!emailRegex.test(contactState.email)) {
      setIsEmailDialogOpen(true);
      return;
    }

    if (contactState.captcha !== "") {
      setIsLoading(true);
      (async () => {
        await axios.post(process.env.REACT_APP_API_BASE_URL + '/market/contact', contactState);
        setIsLoading(false);
        setIsSuccessDialogOpen(true);
      })();
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessDialogOpen(false);
  };

  const handleFailedClose = () => {
    setIsFailedDialogOpen(false);
  }

  const handleEmailClose = () => {
    setIsEmailDialogOpen(false);
  }

  return (
    <>
      <Dialog onClose={handleEmailClose} aria-labelledby="success-dialog-title" open={isEmailDialogOpen}>
        <DialogTitle id="success-dialog-title">Email is not valid</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Please fill in the valid email.
          </Typography>
        </DialogContent>
      </Dialog>
      <Dialog onClose={handleSuccessClose} aria-labelledby="success-dialog-title" open={isSuccessDialogOpen}>
        <DialogTitle id="success-dialog-title">Email Sent</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Email sent. Thank you for your inquiry, our customer support will contact you soon!
          </Typography>
        </DialogContent>
      </Dialog>
      <Dialog onClose={handleFailedClose} aria-labelledby="failed-dialog-title" open={isFailedDialogOpen}>
        <DialogTitle id="failed-dialog-title">Captcha Required</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Please fill in the captcha.
          </Typography>
        </DialogContent>
      </Dialog>
      <Backdrop open={isLoading} >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="lg">
        <Grid container spacing={1}>
          <Grid item xs={12} >
            <div className="contact-title">
              INTERESTED TO JOIN US?
            </div>
          </Grid>
          <Grid item xs={12} >
            <div className="contact-subtitle">
              Get started on your journey to jumpstart new sales + cost transformation.
              Fill out the form below to request for a FREE demo session.
            </div>
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField variant="outlined" margin="normal" required fullWidth id="name" label="Name" name="name" size="medium" onChange={handleContactChange}
                inputProps={{ tabIndex: "1" }} autoFocus
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField variant="outlined" margin="normal" required fullWidth id="email" label="Email" name="email" size="medium" onChange={handleContactChange}
                inputProps={{ tabIndex: "2" }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField variant="outlined" margin="normal" required fullWidth id="contact" label="Contact" name="contact" size="medium" onChange={handleContactChange}
                inputProps={{ tabIndex: "3" }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField variant="outlined" margin="normal" required fullWidth id="company" label="Company" name="company" size="medium" onChange={handleContactChange}
                inputProps={{ tabIndex: "4" }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField variant="outlined" margin="normal" required fullWidth id="message" label="Message" name="message" size="medium" multiline rows={6} onChange={handleContactChange}
                inputProps={{ tabIndex: "5" }}
              />
            </Grid>
            <Grid item xs={12}>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                onChange={onCaptchaChange}
                tabIndex={6}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" color="primary" fullWidth onClick={submitContact} tabIndex={7}>Send</Button>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}